/* eslint-disable func-names, max-len */
const self = {
  tableResize,
};

const count = $('.table-item').first().children().length;

// sets table-cell height to be the same per 'row'
function tableResize() {
  $('.table-cell').css('height', 'auto');
  $.each(new Array(count), (i) => {
    let rowHeight = 0;
    $(`.table-row-${i + 1}`).each(function () {
      if ($(this).children('.table-cell').outerHeight() > rowHeight) {
        rowHeight = $(this).children('.table-cell').outerHeight();
      }
    });
    $(`.table-row-${i + 1}`).children('.table-cell').css('height', rowHeight);
  });
}

const $table = $('.best-table');
if ($table.length) {
  if ($table.find('.table-item').length === 2) {
    $table.siblings('.mob-table-nav').hide();
  }

  self.tableResize();

  let nbClickRight = 0;

  // on click of right button slide the table inner if it isn't disabled
  $('.view-more-batteries .right-arrow').click(() => {
    if (!$('.view-more-batteries').hasClass('right-disabled')) {
      $('.view-more-batteries').removeClass('left-disabled');

      if (nbClickRight === 0) {
        $('.table-inner').animate({
          left: '-100%',
        }, 1000);

        // hide first two
        $('.prod-table .fixed').eq(0).addClass('mobile-hidden');
        $('.prod-table .fixed').eq(1).addClass('mobile-hidden');

        nbClickRight += 1;
      } else if (nbClickRight === 1) {
        $('.table-inner').animate({
          left: '-150%',
        }, 1000);

          // hide first three
        $('.prod-table .fixed').eq(2).addClass('mobile-hidden');

        $('.view-more-batteries').addClass('right-disabled');
      }
    }
  });

  // on click of left button slide the table inner if it isn't disabled
  $('.view-more-batteries .left-arrow').click(() => {
    nbClickRight = 0;

    if (!$('.view-more-batteries').hasClass('left-disabled')) {
      if (!$('.view-more-batteries').hasClass('left-disabled')) {
        $('.view-more-batteries').removeClass('right-disabled');
        $('.table-inner').animate({
          left: '0',
        }, 1000);

        // show first three
        $('.prod-table .fixed').eq(0).removeClass('mobile-hidden');
        $('.prod-table .fixed').eq(1).removeClass('mobile-hidden');
        $('.prod-table .fixed').eq(2).removeClass('mobile-hidden');
        $('.view-more-batteries').addClass('left-disabled');
      }
    }
  });

  $(window).resize(() => {
    tableResize();

    if ($(window).innerWidth() > 767) {
      $('.table-inner').removeAttr('style');

      $('.view-more-batteries').removeClass('right-disabled');
      $('.view-more-batteries').addClass('left-disabled');
    }
  });
}

export default self;
